import { useFeatureFlagEnabled } from "posthog-js/react"
import posthog from "posthog-js"

/**
 * The driver workspace — the split driver-room layout (Slick AI column plus
 * the Chat / Automations / Map widget panel), the composer redesign and the
 * chat restyles that come with it. One flag for the whole change: with it off
 * the app behaves exactly as it did before the branch.
 */
export const AGENT_FOR_DRIVER_PER_CHAT_FLAG = "agent-for-driver-per-chat"

/**
 * The synchronous read, for thunks and stanza handlers that have no render to
 * hook into. PostHog resolves flags async, so never cache the result.
 */
export const isAgentForDriverPerChatEnabled = (): boolean =>
  posthog.isFeatureEnabled(AGENT_FOR_DRIVER_PER_CHAT_FLAG) === true

/**
 * `useFeatureFlagEnabled` is undefined on the first render (it resolves in a
 * post-mount effect), which would flash the old layout before flipping to the
 * new one. Fall back to the synchronous cached value so the first paint is
 * already correct — same pattern the `ai-streaming` gate uses.
 */
export const useAgentForDriverPerChat = (): boolean => {
  const flag =
    useFeatureFlagEnabled(AGENT_FOR_DRIVER_PER_CHAT_FLAG) ??
    isAgentForDriverPerChatEnabled()
  return flag === true
}
